import React, { useEffect, useRef, useState } from 'react';
import { Buffer } from 'buffer';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

import DynamicForm from '../../dynamicForm/DynamicForm';
import { ActionIconItem } from '../../others/ActionIconItem';

import { useDataAuth } from '../../../hooks/useDataAuth';
import { useNotification } from '../../../hooks/useNotification';
import { useValidateDynamicForm } from '../../../hooks/useValidateDynamicForm';
import { ActionButtons } from '../../others/ActionButtons';
import LoadingOverlay from '../../others/LoadingOverlay';
import { useForm } from '../../../hooks/useForm';
import { useApiResolver } from '../../../hooks/useApiResolver';

import { isNotEmptyObject, safeParseJSON, safeParseJSONNotRef } from '../../../utils/jsonValidator';
import useResolveCompanyInfo from '../../../hooks/useResolveCompanyInfo';
import { useResolveBodyData } from '../../../hooks/useResolveBodyData';
import { serializeSchemeValues } from '../../../helpers/configResolver';
import { deepClone } from '../../../utils/jsonUtils';


export const ModalForms = ({ data, id_user_action, parent, handleChange, DocManager, requires_check }) => {
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const { resolveValue } = useApiResolver();
    const { rowsChecked, handleRowsChecked } = DocManager;
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isSubmittingRef = useRef(false);
    const companyInfo = useResolveCompanyInfo();
    const [errorInputs, validForm, resetErrors] = useValidateDynamicForm();
    // eslint-disable-next-line no-unused-vars
    const [valuesForm, handleInputChange, handleDirectInputChange, _, reset] = useForm({ id_user_action });
    // console.log('data.trigger[0]?.bodyData ', data.trigger[0]?.bodyData);
    const { resolveInfo, resetInit, templateHasPlaceholder } = useResolveBodyData(data.trigger[0]?.bodyData);

    const vbles = {
        ...companyInfo,
        id_parent: parent?.id || null,
    };

    useEffect(() => {
        resolveInfo(companyInfo);
    }, [open])

    const setFileTemp = (bytes, field) => {
        const u8 = new Uint8Array(bytes);
        var b64 = Buffer.from(u8).toString('base64');
        handleDirectInputChange(field + '_file_B64', b64);
    }

    const handleFileChange = (event, field) => {
        handleDirectInputChange(field, event.target.files[0].name);
        const asfile = event.target.files[0];
        if (asfile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const bytes = new Uint8Array(arrayBuffer);
                setFileTemp(bytes, field);
            };
            reader.readAsArrayBuffer(asfile);
        }
        event.target.value = '';
    };

    const formFieldIds = new Set((data?.form || []).map((field) => field.id));

    const setValuesSelectGeneric = (e) => {
        const { name, value, fullObject } = e.target;
        const updates = { [name]: value };
        if (isNotEmptyObject(fullObject)) {
            const reservedKeys = new Set(['id', 'code']);
            for (const key of Object.keys(fullObject)) {
                const prefixed = `${name}_${key}`;
                if (templateHasPlaceholder(prefixed) || formFieldIds.has(prefixed)) {
                    updates[prefixed] = fullObject[key];
                }
                if (
                    key !== name &&
                    !reservedKeys.has(key) &&
                    (formFieldIds.has(key) || templateHasPlaceholder(key))
                ) {
                    updates[key] = fullObject[key];
                }
            }
        }
        handleDirectInputChange(updates);
    }

    const CallApi = async (param) => {
        if (isSubmittingRef.current) return;
        if (!validForm(data.form, valuesForm)) return;

        isSubmittingRef.current = true;
        setIsLoading(true);

        try {
            const trigger = param.trigger;
            const url = trigger[0]?.url;
            const method = trigger[0]?.method;
            const resolvedBody = resolveInfo(serializeSchemeValues(valuesForm, data.form), null, true, vbles);
            const variables = safeParseJSONNotRef(resolvedBody.variables);
            const filters = {};

            if (parent) {
                const prnt = { ...parent };
                delete prnt.propiedad;
                filters.id_unique = {
                    "value": prnt.id_unique,
                    "operator": "=",
                    "type": "string"
                }
                if (DocManager?.rowsCheckedDetails.length > 0)
                    filters.id = {
                        "value": DocManager?.rowsCheckedDetails.join(","),
                        "operator": "IN",
                        "type": "string"
                    }
            } else {
                filters.id_unique = {
                    "value": DocManager?.rowsChecked.join(","),
                    "operator": "IN",
                    "type": "string"
                }
            }
            variables.filters = filters;
            const filt = JSON.stringify(variables);

            if (requires_check === 'true') {
                if (rowsChecked?.length > 0 || DocManager?.rowsCheckedDetails.length > 0)
                    resolvedBody.variables = filt;
                else {
                    sendNotification({ msg: 'Debes selecionar por lo menos una fila', variant: 'error' });
                    return false;
                }
            }
            else {
                if (DocManager?.rowsChecked.length > 0 || DocManager?.rowsCheckedDetails.length > 0)
                    resolvedBody.variables = filt;
                else {
                    const fil = deepClone(DocManager?.filters);
                    if (parent) {
                        const prnt = { ...parent };
                        delete prnt.propiedad;
                        fil.id_unique = {
                            "value": prnt.id_unique,
                            "operator": "=",
                            "type": "string"
                        }
                    }
                    variables.filters = fil;
                    resolvedBody.variables = JSON.stringify(variables);
                }
            }

            if (parent) {
                const prnt = { ...parent };
                delete prnt.propiedad;
                resolvedBody.parent = prnt;
            }

            for (let key in resolvedBody) {
                if (resolvedBody[key] === '{attached}') {
                    resolvedBody[key] = valuesForm[key]
                }
            }

            let str = JSON.stringify(resolvedBody);
            for (let key in valuesForm) {
                let value = valuesForm[key];
                value = String(value || '').replace(/"/g, '\\"').replace(/[\r\n]+/g, ' ');
                if (value === `{${key}}`)
                    value = ''
                str = str.toString().replace(`{${key}}`, value).replace(`{[form].${key}}`, value);
            }
            let config = {
                method: method,
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userSession.token}`
                },
                data: str
            };
            handleRowsChecked([]);

            const response = await resolveValue(config, param?.response_type !== 'download');
            if (response.status === 200) {
                if (param?.response_type === 'download') {
                    console.log("response ", response);
                    let ext = param.name_file.split('.').pop();
                    const byteCharacters = atob(response.data);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: `application/${ext}` });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', param.name_file.replace('{date}', moment().format('YYYY-MM-DDTHH:mm:ssZ')));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                if (!response.errorCode) {
                    handleOpenModal(false);
                    setTimeout(() => {
                        handleChange();
                    }, 500);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            isSubmittingRef.current = false;
            setIsLoading(false);
        }
    }

    const handleOpenModal = (isOpen) => {
        setOpen(isOpen);
        if (!isOpen) {
            resetErrors();
            reset();
            resetInit();
        }
    }

    return (
        <React.Fragment>
            <ActionIconItem
                item={data}
                onClick={() => handleOpenModal(true)}
                height={35}
            />

            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{
                    sx: {
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        width: {
                            xs: '100%',
                            md: data?.width ? `${data.width}%` : '35%'
                        },
                        margin: { xs: 1, md: 0 },
                        maxHeight: '90vh',
                        borderRadius: 2,
                    }
                }}
            >
                <DialogTitle sx={{ borderBottom: '1px solid #ccc' }}>
                    <Typography id="form-modal-title" variant="h6" component="h2">
                        {data.accion}
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ overflowY: 'auto', flexGrow: 1 }}>
                    <DynamicForm
                        values={valuesForm}
                        scheme={data.form}
                        errorInputs={errorInputs}
                        onChange={handleInputChange}
                        handleFileChange={handleFileChange}
                        setChanges={handleDirectInputChange}
                        setValuesSelectGeneric={setValuesSelectGeneric}
                        companyInfo={vbles}
                    />
                </DialogContent>

                <DialogActions sx={{ borderTop: '1px solid #ccc' }}>
                    <ActionButtons
                        onSubmit={() => CallApi(data)}
                        onCancel={() => handleOpenModal(false)}
                        disabledSubmit={isLoading}
                        disabledCancel={isLoading}
                    />
                </DialogActions>

                <LoadingOverlay
                    isOpen={isLoading}
                    text="Esperando ..."
                    contained
                />
            </Dialog>
        </React.Fragment>
    )
}